export enum TosUpdatedDatesStatus {
  NotLoaded = 'NotLoaded',
  Loading = 'Loading',
  Loaded = 'Loaded',
  Error = 'Error',
}

export type TosType = 'general' | 'ios';

export type TosUpdatedDates = {
  general: string;
  ios: string;
};

export type ApplicationState = {
  tosUpdatedDates: {
    status: TosUpdatedDatesStatus;
    dates: TosUpdatedDates | null;
  };
  tosNextUpdateDates: {
    status: TosUpdatedDatesStatus;
    dates: TosUpdatedDates | null;
  };
};

export type ApplicationData = {
  tosUpdatedDates: TosUpdatedDates;
};
